export const config = {
  api: "https://c14bne08v7.execute-api.eu-west-2.amazonaws.com",
  mapboxToken:
    "pk.eyJ1IjoiaW5zaWdodC1hY2NvdW50cyIsImEiOiJja2xodXo2amsybW9lMnBzOGk2ZDZicXU4In0.26fRgoPixMDN9uwMpb6QIw",
};
